import { Bot, BrainCircuit, Network, Coins } from "lucide-react";
import { CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { A2AAgent } from "@/utils/a2a/types";
import { OrchestrationInsights } from "./types";

interface AIAssistantHeaderProps {
  orchestrationActive: boolean;
  orchestrationInsights: OrchestrationInsights | null;
  availableAgents: A2AAgent[];
  taskComplexity: string;
  totalTokens: number;
  cost: number;
  className?: string;
}

export const AIAssistantHeader = ({
  orchestrationActive,
  availableAgents,
  taskComplexity,
  totalTokens,
  cost,
  className,
}: AIAssistantHeaderProps) => {
  const renderOrchestration =
    orchestrationActive && (
      <span className="ml-auto flex items-center text-sm font-normal text-muted-foreground">
        <BrainCircuit className="h-4 w-4 mr-1 animate-pulse text-amber-500" />
        Orchestrating{" "}
        {
          availableAgents.filter(
            (a) => a.isAvailable && a.id !== "executive-agent"
          ).length
        }{" "}
        agents
        {taskComplexity === "complex" ? (
          <Network className="h-4 w-4 ml-1 text-blue-500" />
        ) : null}
        ...
      </span>
    );

  const renderUsage =
    totalTokens > 0 && !orchestrationActive ? (
      <span className="ml-auto flex items-center text-sm font-normal text-muted-foreground">
        <Coins className="h-4 w-4 mr-1 text-green-500" />
        {totalTokens} tokens (${cost.toFixed(4)})
      </span>
    ) : null;

  return (
    <CardHeader className={cn("px-4 py-3 border-b bg-card shadow-sm", className)}>
      <CardTitle className="text-lg font-medium flex items-center">
        <Bot className="h-5 w-5 mr-2 text-primary" />
        BrigAI Assistant
        {renderOrchestration}
        {renderUsage}
      </CardTitle>
    </CardHeader>
  );
};
